enum ButtonColors {
    orange,
    aqua,
    blue,
    black,
    white,
    red
}

export default ButtonColors;